import { render } from "./PopperContent.vue?vue&type=template&id=3b4647e6"
import script from "./PopperContent.vue?vue&type=script&lang=js"
export * from "./PopperContent.vue?vue&type=script&lang=js"

import "./PopperContent.vue?vue&type=style&index=0&id=3b4647e6&lang=css"

import exportComponent from "D:\\Projects\\jimoty\\JimotyWeb\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__